import { Experiment, Treatment as TreatmentTypeFromSDK } from '@grammarly/experimentation-js-sdk'

export const ManakinExperiments = {
  // GSF-3313 updating browser pages (extensions downloads) to a sign-up first flow
  BrowserPagesSignUpFlow: new Experiment('browser_page_signup_first_flow', ['control', 'test']),
} as const

export const StatsigExperiments = {
  // G2A-1380 Google CTA on Tool Page Sign Up Walls
  GoogleCtaSignupWallV2: new Experiment('google_cta_signup_wall_v2', ['control', 'test']),

  // G2A-1804 Tools Secondary Nav
  ToolsSecondaryNav: new Experiment('lp_tool_secondary_nav', ['control', 'test']),

  // G2A-1931 Tools Seconday Nav Logged In
  ToolsSecondaryNavLoggedIn: new Experiment('lp_tool_secondary_nav_logged_in', ['control', 'test']),

  ToolsSecondaryNavMobile: new Experiment('lp_tool_secondary_nav_mobile', ['control', 'test']),

  // G2A-1732 Signed In DesktopEditor vs Persistent Client CTA
  SignedInDesktopEditorPersistentClientCta: new Experiment('signedin_editor_vs_persistent_client_cta', [
    'control',
    'test_editor_cta',
    'test_persistent_client_cta',
  ]),

  // G2A-1952 Signed In Paid LP Desktop Editor vs Persistent Client CTA
  SignedInPaidLPHeroCta: new Experiment('signedin_paidlps_hero', [
    'control',
    'test_editor_cta',
    'test_persistent_client_cta',
  ]),

  // G2A-1860 Tools Optimal Value Exchange
  ToolsOptimalUsageLimit: new Experiment('tools_optimal_usage_limit', [
    'control',
    'low_usage_limit',
    'medium_usage_limit',
    'high_usage_limit',
  ]),

  // G2A-1958 Free use limit to trial
  ToolsFreeUseLimitToTrial: new Experiment('tool_free_use_limit_to_trial', ['control', 'limit_3', 'limit_5']),

  ToolsRedesign2_2: new Experiment('tools_redesign_2_2', ['control', 'test']),

  // G2A-2050 Tools Redesign 2.2 Logged In
  ToolsRedesign2_2LoggedIn: new Experiment('tools_redesign_2_2_logged_in', ['control', 'test']),

  // G2A-2026 Tools Redesign 2.3 Anonymous (mobile and desktop)
  ToolsRedesign2_3Anon: new Experiment('tools_redesign_2_3_anon', ['control', 'test']),

  // G2A-2024 Tools Google One Tap
  ToolsGoogleOneTap: new Experiment('tools_google_one_tap', ['control', 'page_load', 'task_complete']),

  // G2A-2009 Tools LTV Personalized Nav
  ToolsLtvNav: new Experiment('tools_ltv_nav_expanded', ['control', 'test']),

  // G2A-2004 Page Path Validation
  PagePathValidation: new Experiment('page_path_tracking_validation', ['control', 'test']),

  // G2A-2011 Automatic Sign in
  AutomaticSignIn: new Experiment('automatic_sign_in', ['control', 'test']),

  // G2A-2053 Paid LP Google One Tap
  PaidLPGoogleOneTap: new Experiment('paid_lp_google_one_tap', ['control', 'test']),

  // Tools Exit Intent Modal
  ToolPageExitIntentModal: new Experiment('tool_page_exit_intent_modal', ['control', 'test']),

  // G2A-2080 Global Nav Anonymous Trial Upgrade Hook
  GlobalNavAnonymousTrialUphook: new Experiment('global_nav_anonymous_trial_uphook', [
    'control',
    'busy_global_nav_w_free_trial_upook',
    'cleaner_global_nav_w_free_trial_uphook',
  ]),
} as const

export const ExperimentNamesSet: Set<string> = new Set(
  Object.values({ ...ManakinExperiments, ...StatsigExperiments }).map((experiment) => experiment.name)
)

type Treatment<E extends Experiment> = E extends Experiment<infer Treatment> ? Treatment : never

export type TreatmentOrNull<E extends Experiment> = Treatment<E> | null

export type StatsigTreatmentOrNull<E extends Experiment> = Treatment<E> | null | 'NOT_ASSIGNED'

/**
 * TreatmentWithAssignedGroup extends the Treatment type from experimentation sdk.
 * It replaces the prop groupName with assignedGroup, which represents the assigned (not just peeked) group for experiments.
 * The assignedGroup will also not have a suffix of _1 or _2
 */
export type TreatmentWithAssignedGroup = Omit<TreatmentTypeFromSDK, 'groupName'> & {
  assignedGroup: string
}
